import { BaIcon } from '@/components/atoms/ba-icon/vue';

export default {
  components: {
    BaIcon,
  },
  props: {
    tagName: {
      type: String,
      default: 'button',
    },
    icon: {
      type: String,
    },
    to: String,
    modCircular: Boolean,
    modDark: Boolean,
    modDisabled: Boolean,
    modIconAfter: Boolean,
    modIconBefore: Boolean,
    modImportant: Boolean,
    modList: Boolean,
    modNaked: Boolean,
    modSimulation: Boolean,
  },
  computed: {
    classes() {
      return [
        'ba-button',
        {
          'ba-button--dark': this.modDark,
          'ba-button--disabled': this.modDisabled,
          'ba-button--simulation': this.modSimulation,
          'ba-button--circular': this.modCircular,
          'ba-button--important': this.modImportant,
          'ba-button--naked': this.modNaked,
          'ba-button--list': this.modList,
        },
      ];
    },
    inputListeners() {
      return Object.assign(
        {},
        this.$listeners,
      );
    },
  },
};
